import React, { useEffect, useRef, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { Button, Checkbox, Col, Form, Input, InputNumber, Row, Select, Spin } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import Title from 'antd/es/typography/Title';
import { APP_LOCAL_DATE_FORMAT_PAYLOAD } from 'app/config/constants';
import { checkInKrQuantiMonth, checkInKrQuantiQuarter, checkInQuantitativeMidYear, getKrQuantiCheckInMidYear, reset } from 'app/entities/checkIn/checkIn.reducer';
import { getBoxWorkStatus } from 'app/entities/common/common.reducer';
import { checkInKrQuantiAdjust } from 'app/entities/kr/kr-quantitative.reducer';
import ObjectiveUpdate from 'app/entities/objective/form/objective-update';
import AdjustObjectiveUpdate from 'app/entities/objective/form/objective-update-adjustment';
import { StatusType } from 'app/shared/model/enum/status.enum';
import { displayPercent, percent } from 'app/shared/util/percent';
import { filterOption } from 'app/shared/util/select-filter';
import dayjs from 'dayjs';
import * as _ from 'lodash';
import KRUpdate from '../../kr-update';
import { formatNumber, parseNumber } from 'app/shared/util/help';
import { getEntity as getDetailObject } from 'app/entities/objective/objective.reducer';
import { TrendingTypes } from 'app/shared/model/enum/trending.enum';
import { KrTypes } from 'app/shared/model/enum/kr.enum';
import { EvaluationTypes } from 'app/shared/model/enum/evaluation-type.enum';
import { QuantitativeEvaluationType } from 'app/shared/model/enum/quantitativeEvaluation.enum';
import { log } from 'react-jhipster';

type IReportQualitativeResult = {
  handleClose: () => void;
  krCheckIn?: any;
  handleNextData: () => void;
  hideNextKr: boolean;
};

export const ReportQuantitativeResult = ({ handleClose, krCheckIn, handleNextData, hideNextKr }: IReportQualitativeResult) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const filters = useAppSelector(state => state.filters.orgCheckIn);
  const objectiveEntity = useAppSelector(state => state.objective.entity);
  const workStatusList = useAppSelector(state => state.common.workStatus);
  const entity = useAppSelector(state => state.checkIn.entity);

  const [compareAdjustmentYear, setCompareAdjustmentYear] = useState([]);
  const [isOpenAdjustmentModel, setOpenAdjustmentModel] = useState(false);
  const [isOpenModalFormKr, setIsOpenModalFormKr] = useState(false);
  const [isOpenModalFormObjective, setIsOpenModalFormObjective] = useState(false);
  const [isUpdating, setUpdating] = useState(false);
  const modalContentRef = useRef(null);

  const [adjustmentValue, setAdjustmentValue] = useState(entity?.adjustment?.isAdjustment === true ? 'adjustment' : 'noAdjustment');
  const [isAdjustment, setIsAdjustment] = useState<string>(entity?.adjustment?.isAdjustment === true ? 'adjustment' : 'noAdjustment');

  useEffect(() => {
    if (entity?.adjustment?.isAdjustment !== undefined) {
      const newValue = entity?.adjustment?.isAdjustment === true ? 'adjustment' : 'noAdjustment';
      setAdjustmentValue(newValue);
      setIsAdjustment(newValue);
    }
  }, [entity]);

  useEffect(() => {
    if (adjustmentValue) {
      setIsAdjustment(adjustmentValue);
    }
  }, [adjustmentValue]);

  useEffect(() => {
    if (isUpdating) {
      handleClose();
    }
  }, [isUpdating]);

  // watch values form
  const workStatusMonthValues = Form.useWatch('workStatusMonth', form);
  const metricValueMonthValues = Form.useWatch('metricValueMonth', form);
  const metricValueQuarterValues = Form.useWatch('metricValueQuarter', form);
  const accumulateResultValues = Form.useWatch('accumulatedResult', form);
  const workStatusQuarterValues = Form.useWatch('workStatusQuarter', form);
  const metricValueYearValues = Form.useWatch('metricValue-0', form);
  const metricValueFirstValues = Form.useWatch('metricValue-1', form);
  const metricValueSecondValues = Form.useWatch('metricValue-2', form);
  const metricValueThirdValues = Form.useWatch('metricValue-3', form);
  const metricValueJulValues = Form.useWatch('metricValue-4', form);
  const metricValueAugValues = Form.useWatch('metricValue-5', form);
  const metricValueSepValues = Form.useWatch('metricValue-6', form);
  const metricValueFourthValues = Form.useWatch('metricValue-7', form);
  const metricValueOctValues = Form.useWatch('metricValue-8', form);
  const metricValueNovValues = Form.useWatch('metricValue-9', form);
  const metricValueDecValues = Form.useWatch('metricValue-10', form);

  // Add this useEffect after other useEffects
  const metricValueMayValues = Form.useWatch('metricValueMay', form);
  const accumulateActualResultPreviousMonthValues = Form.useWatch('accumulateActualResultPreviousMonth', form);



  useEffect(() => {
    if (krCheckIn && filters) {
      innitData();
    }
  }, [krCheckIn, filters]);


  useEffect(() => {
    if (entity) {
      form.setFieldValue('reportScheduleName', entity?.reportScheduleName)
      form.setFieldValue('planPeriodName', entity?.planPeriodName)
      if (entity?.keyResultMonth) {
        form.setFieldValue('metricValueMonth', entity?.keyResultMonth?.result)
        form.setFieldValue('workStatusMonth', entity?.keyResultMonth?.workStatus)
        form.setFieldValue('unFinishNoteMonth', entity?.keyResultMonth?.unFinishNote)
        form.setFieldValue('estimatePointMonth', displayPercent(entity?.keyResultMonth?.estimatePoint))
      }

      if (entity?.keyResultPreviousMonth) {
        form.setFieldValue('metricValuePreviousMonth', entity?.keyResultPreviousMonth?.metricValue)
        form.setFieldValue('accumulateActualResultPreviousMonth', entity?.keyResultPreviousMonth?.actualResult ?? 0);
        form.setFieldValue('accumulateResultPreviousMonth', entity?.keyResultPreviousMonth?.result ?? 0);
      }

      if (entity?.keyResultQuarter) {
        form.setFieldValue('metricValueMay', entity?.keyResultQuarter?.metricValue)
        form.setFieldValue('metricValueQuarter', entity?.keyResultQuarter?.result)
        form.setFieldValue('noteQuarter', entity?.keyResultQuarter?.note)
        form.setFieldValue('unFinishNoteQuarter', entity?.keyResultQuarter?.unFinishNote)
        form.setFieldValue('workStatusQuarter', entity?.keyResultQuarter?.workStatus)
        form.setFieldValue('estimatePointQuarter', displayPercent(entity?.keyResultQuarter?.estimatePoint))
        form.setFieldValue('accumulateResult', entity?.keyResultQuarter?.accumulateResult ?? 0);
        form.setFieldValue('accumulatePoint', entity?.keyResultQuarter?.accumulatePoint);
      }

      if (entity?.adjustment) {
        form.setFieldValue('reason', entity?.adjustment?.adjustmentReason)
        form.setFieldValue('issue', entity?.adjustment?.adjustmentIssue)
        form.setFieldValue('krAdjustmentNote', entity?.adjustment?.adjustmentNote)
        form.setFieldValue('solution', entity?.adjustment?.adjustmentSolution)
      }

      if (entity?.keyResultYear) {
        form.setFieldValue('metricValueYearValues', entity?.keyResultYear?.result)
        form.setFieldValue('noteYear', entity?.keyResultYear?.note)
        form.setFieldValue('unFinishNoteYear', entity?.keyResultYear?.unFinishNote)
        form.setFieldValue('workStatusYear', entity?.keyResultYear?.workStatus)
        form.setFieldValue('estimatePointYear', displayPercent(entity?.keyResultYear?.estimatePoint))
        form.setFieldValue('accumulateResult', entity?.keyResultYear?.accumulateResult ?? 0);
        form.setFieldValue('accumulatePoint', entity?.keyResultYear?.accumulatePoint);
      }
    }
  }, [entity]);

  useEffect(() => {
    if (entity?.keyResultQuarter && krCheckIn?.krType === KrTypes.AccumulateQuantitative) {
      const currentQuarterValue = entity?.keyResultQuarter?.result || 0;
      const juneValue = metricValueMonthValues || 0;
      const previousMonthValue = accumulateActualResultPreviousMonthValues || 0;

      // Công thức đúng: Thực hiện quý II = Ban đầu + Tháng 6 + Chốt thực hiện tháng 5
      const totalQuarterValue = currentQuarterValue + juneValue + previousMonthValue;

      if (_.isInteger(totalQuarterValue)) {
        form.setFieldValue('metricValueQuarter', totalQuarterValue);
        form.setFieldValue('metricValue-2', totalQuarterValue);
      } else {
        form.setFieldValue('metricValueQuarter', parseFloat(totalQuarterValue.toFixed(2)));
        form.setFieldValue('metricValue-2', parseFloat(totalQuarterValue.toFixed(2)));
      }

      // Calculate Q2 comparison percentage
      if (entity?.keyResultQuarter?.metricValue !== 0) {
        const comparisonPercent = calculatorPercentByTrending(
          entity?.keyResultQuarter?.metricType,
          totalQuarterValue,
          entity?.keyResultQuarter?.metricValue
        ) * 100;
        form.setFieldValue('estimatePointQuarter', parseFloat(comparisonPercent?.toFixed(2)));
      }

      // Calculate and update accumulated result
      const accumulatedValue = (entity?.keyResultQuarter?.accumulateResult ?? 0) + (totalQuarterValue ?? 0) - (entity?.keyResultQuarter?.result ?? 0);
      if (_.isInteger(accumulatedValue)) {
        form.setFieldValue('accumulateResult', accumulatedValue);
      } else {
        form.setFieldValue('accumulateResult', parseFloat(accumulatedValue?.toFixed(2)));
      }

      // Calculate percentage for accumulated vs year KR
      if (entity?.keyResultYear?.metricValue !== 0) {
        const accumulatedPercent = calculatorPercentByTrending(
          entity?.keyResultYear?.metricType,
          accumulatedValue,
          entity?.keyResultYear?.metricValue
        ) * 100;
        form.setFieldValue('accumulatePoint', parseFloat(accumulatedPercent?.toFixed(2)));
      }
    }
  }, [
    entity?.keyResultQuarter,
    metricValueMonthValues,
    accumulateActualResultPreviousMonthValues,
    krCheckIn?.krType
  ]);

  useEffect(() => {
    if (entity?.keyResultQuarter?.evaluationMethodQuantitative === QuantitativeEvaluationType.Point) {
      if (entity && entity?.keyResultMonth?.metricValue !== 0) {
        const result = displayPercent(calculatorPercentByTrending(entity?.keyResultQuarter?.metricType, metricValueMonthValues, entity?.keyResultMonth?.metricValue));
        if (_.isInteger(result))
          form.setFieldValue('estimatePointMonth', result)
        else
          form.setFieldValue('estimatePointMonth', result.toFixed(2))
      }
    }
  }, [metricValueMonthValues, entity?.keyResultQuarter?.evaluationMethodQuantitative, entity?.keyResultMonth?.metricValue])





  // Watch form values changes
  const metricValue2 = Form.useWatch('metricValue-2', form);
  const estimatePointMonth = Form.useWatch('estimatePointMonth', form);

  useEffect(() => {
    if (entity?.keyResultQuarter?.evaluationMethodQuantitative === QuantitativeEvaluationType.Point) {
      if (entity?.keyResultQuarter?.metricValue !== 0) {
        const result = displayPercent(calculatorPercentByTrending(entity?.keyResultQuarter?.metricType, metricValueQuarterValues, entity?.keyResultQuarter?.metricValue));
        if (entity?.keyResultQuarter?.evaluationMethodQuantitative === QuantitativeEvaluationType.Point) {
          if (_.isInteger(result))
            form.setFieldValue('estimatePointQuarter', result)
          else
            form.setFieldValue('estimatePointQuarter', result.toFixed(2))
        }
      }
    }

    // Calculate accumulated result when Q2 value changes
    if (krCheckIn?.krType === KrTypes.AccumulateQuantitative && metricValueQuarterValues !== null && metricValueQuarterValues !== undefined) {
      // Calculate accumulated result
      const accumulatedValue = (entity?.keyResultQuarter?.accumulateResult ?? 0) + (metricValueQuarterValues ?? 0) - (entity?.keyResultQuarter?.result ?? 0);
      if (_.isInteger(accumulatedValue)) {
        form.setFieldValue('accumulateResult', accumulatedValue);
      } else {
        form.setFieldValue('accumulateResult', parseFloat(accumulatedValue?.toFixed(2)));
      }

      // Calculate percentage for accumulated vs year KR
      if (entity?.keyResultYear?.metricValue !== 0) {
        const accumulatedPercent = displayPercent(
          calculatorPercentByTrending(entity?.keyResultQuarter?.metricType, accumulatedValue, entity?.keyResultYear?.metricValue)
        );
        if (_.isInteger(accumulatedPercent)) {
          form.setFieldValue('accumulatePoint', accumulatedPercent);
        } else {
          form.setFieldValue('accumulatePoint', parseFloat(accumulatedPercent?.toFixed(2)));
        }
      }
    }
  }, [metricValueQuarterValues])

  // Đồng bộ giá trị "Thực hiện quý II" với "Thực hiện quý 2" trong phần điều chỉnh (chỉ với loại tích lũy)
  useEffect(() => {
    if (krCheckIn?.krType === KrTypes.AccumulateQuantitative && metricValueQuarterValues !== null && metricValueQuarterValues !== undefined) {
      form.setFieldValue('metricValue-2', metricValueQuarterValues);
    }
  }, [metricValueQuarterValues, krCheckIn?.krType]);

  useEffect(() => {
    if (krCheckIn?.krType === KrTypes.AccumulateQuantitative) {
      if (entity?.keyResultYear?.metricValue !== 0) {
        const result = displayPercent(
          calculatorPercentByTrending(entity?.keyResultQuarter?.metricType, accumulateResultValues, entity?.keyResultYear?.metricValue),
        );
        if (_.isInteger(result)) form.setFieldValue('accumulatePoint', result);
        else form.setFieldValue('accumulatePoint', result.toFixed(2));
      }
    }
  }, [accumulateResultValues]);

  // tự động tính giá trị điều chỉnh của các tháng
  useEffect(() => {
    if (krCheckIn?.krType === KrTypes.AccumulateQuantitative) {
      const valueYear =
        (metricValueYearValues ?? 0) - ((metricValueFirstValues ?? 0) + (metricValueSecondValues ?? 0) + (metricValueThirdValues ?? 0));
      if (_.isInteger(valueYear))
        form.setFieldValue('metricValue-7', valueYear);
      else
        form.setFieldValue('metricValue-7', Number(valueYear.toFixed(2)));
    }
  }, [metricValueThirdValues, metricValueSecondValues, metricValueYearValues]);

  useEffect(() => {
    if (krCheckIn?.krType === KrTypes.AccumulateQuantitative) {
      const sepValue = (metricValueThirdValues ?? 0) - (metricValueJulValues ?? 0) - (metricValueAugValues ?? 0);
      if (_.isInteger(sepValue))
        form.setFieldValue('metricValue-6', sepValue);
      else {
        form.setFieldValue('metricValue-6', Number(sepValue.toFixed(2)));
      }
    }
  }, [metricValueJulValues, metricValueAugValues, metricValueThirdValues]);

  useEffect(() => {
    if (krCheckIn?.krType === KrTypes.AccumulateQuantitative) {
      const decValue = (metricValueFourthValues ?? 0) - (metricValueOctValues ?? 0) - (metricValueNovValues ?? 0);
      if (_.isInteger(decValue))
        form.setFieldValue('metricValue-10', decValue);
      else {
        form.setFieldValue('metricValue-10', Number(decValue.toFixed(2)));
      }
    }
  }, [metricValueOctValues, metricValueNovValues, metricValueFourthValues]);

  useEffect(() => {
    const newCompareAdjustmentYear = [...compareAdjustmentYear];

    handleCompareInit(metricValueYearValues, 0, newCompareAdjustmentYear)
    handleCompareInit(metricValueFirstValues, 1, newCompareAdjustmentYear)
    handleCompareInit(metricValueSecondValues, 2, newCompareAdjustmentYear)
    handleCompareInit(metricValueThirdValues, 3, newCompareAdjustmentYear)
    handleCompareInit(metricValueJulValues, 4, newCompareAdjustmentYear)
    handleCompareInit(metricValueAugValues, 5, newCompareAdjustmentYear)
    handleCompareInit(metricValueSepValues, 6, newCompareAdjustmentYear)
    handleCompareInit(metricValueFourthValues, 7, newCompareAdjustmentYear)
    handleCompareInit(metricValueOctValues, 8, newCompareAdjustmentYear)
    handleCompareInit(metricValueNovValues, 9, newCompareAdjustmentYear)
    handleCompareInit(metricValueDecValues, 10, newCompareAdjustmentYear)
  }, [metricValueSecondValues, metricValueFirstValues, metricValueJulValues, metricValueAugValues, metricValueSepValues, metricValueFourthValues, metricValueYearValues, metricValueThirdValues, metricValueOctValues, metricValueNovValues, metricValueDecValues]);

  useEffect(() => {
    setAdjustmentValue(entity?.adjustment?.isAdjustment === true ? 'adjustment' : 'noAdjustment');
  }, [entity]);

  const innitData = () => {
    dispatch(getBoxWorkStatus({ statusType: 1 }));
    dispatch(getKrQuantiCheckInMidYear({ krId: krCheckIn?.id, planPeriodId: filters?.planPeriodId }));
  };

  const handleCompareInit = (value, index, array) => {
    array[index] = displayPercent(
      calculatorPercentByTrending(entity?.keyResultQuarter?.metricType, value, entity?.adjustment?.krApproved[index].oldMetricValue)
    );
    setCompareAdjustmentYear(array);
  }

  const handleChangeAdjustmentYear = (value, index) => {
    const newCompareAdjustmentYear = [...compareAdjustmentYear];
    newCompareAdjustmentYear[index] = displayPercent(
      calculatorPercentByTrending(entity?.keyResultQuarter?.metricType, value, entity?.adjustment?.krApproved[index].metricValue)
    );

    setCompareAdjustmentYear(newCompareAdjustmentYear);
  };

  const handleOpenModalAdjustmentObjective = () => {
    setOpenAdjustmentModel(true);
  };

  const handleCloseModalAdjustmentObjective = (reload) => {
    setOpenAdjustmentModel(false);
    if (reload) {
      dispatch(getDetailObject(entity?.objective?.id))
    }
  };

  const MapperPayload = (values: any) => {
    const {
      workStatusMonth,
      metricValueMonth,
      unFinishNoteMonth,
      workStatusQuarter,
      metricValueQuarter,
      unFinishNoteQuarter,
      accumulateResult,
      accumulatePoint,
      noteQuarter,
      solution,
      reason,
      issue,
      krAdjustmentNote,
      sendingNotification,
      reportSchedularId,
      estimatePointMonth,
      estimatePointQuarter,
      reportScheduleName,
      planPeriodName,
      accumulateActualResultPreviousMonth,
      accumulateResultPreviousMonth,
      accumulatePointPreviousMonth,
      ...remainingValues
    } = values;
    // Khởi tạo mảng khóa
    const keys = Object.keys(remainingValues);

    // Chia mảng thành các nhóm nhỏ, mỗi nhóm có 3 phần tử
    const groupedKeys = _.chunk(keys, 1);
    const subs = _.map(groupedKeys, group => {
      const mapper = _.map(group, key => {
        return remainingValues[key];
      });
      return _.zipObject(['metricValue'], mapper);
    });
    const combinedSubs: any = subs.map((item, index) => {
      if (item.metricValue !== null) {
        return {
          ...item,
          planPeriodId: entity?.adjustment?.krApproved[index].planPeriodId,
          startDate: dayjs(entity?.adjustment?.krApproved[index].startDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
          dueDate: dayjs(entity?.adjustment?.krApproved[index].dueDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
        };
      }
    });
    const valueMonth = {
      reportSchedularId,
      reportObjectId: krCheckIn?.id,
      planPeriodId: entity?.keyResultMonth?.planPeriodId,
      workStatus: workStatusMonth,
      metricValue: metricValueMonth,
      unFinishNote: unFinishNoteMonth,
      note: noteQuarter,
      estimatePoint: percent(estimatePointMonth),
    };
    const valueQuarter = {
      reportSchedularId,
      reportObjectId: krCheckIn?.id,
      planPeriodId: entity?.keyResultQuarter?.planPeriodId,
      workStatus: workStatusQuarter,
      metricValue: metricValueQuarter,
      unFinishNote: unFinishNoteQuarter,
      accumulateResult,
      note: noteQuarter,
      estimatePoint: percent(estimatePointQuarter),
    };
    const valueAdjustment = {
      solution,
      reason,
      issue,
      krId: krCheckIn?.id,
      krAdjustmentNote,
      sendingNotification,
      subs: _.filter(combinedSubs, (o) => { return o !== null && o !== undefined }),
    };

    const valuePreviousMonth = {
      actualResult: accumulateActualResultPreviousMonth,
      result: accumulateResultPreviousMonth,
      accumulatePoint: accumulatePointPreviousMonth,
    }


    return { valueQuarter, valueMonth, valueAdjustment, valuePreviousMonth };
  };
  const handleSubmit = values => {
    const { valueQuarter, valueMonth, valueAdjustment, valuePreviousMonth } = MapperPayload(values);
    setUpdating(true);
    dispatch(checkInQuantitativeMidYear({ krId: krCheckIn?.id, isAdjustment: isAdjustment === 'adjustment' ? true : false, quarter: valueQuarter, month: valueMonth, adjustment: valueAdjustment, prevMonth: valuePreviousMonth })).then(response => {
      const isFailed = _.some(response, (o: any) => {
        return !o.payload;
      });
      if (isFailed) return;
      handleClose();
    })
      .catch(() => {
        return;
      })
      .finally(() => {
        setUpdating(false);
      })
      .catch(() => {
        return;
      });
  };

  const handleNextKr = () => {
    form.validateFields().then(values => {
      const { valueQuarter, valueMonth, valueAdjustment } = MapperPayload(values);
      setUpdating(true);
      Promise.all([
        dispatch(checkInKrQuantiQuarter(valueQuarter)),
        dispatch(checkInKrQuantiMonth(valueMonth)),
        dispatch(checkInKrQuantiAdjust(valueAdjustment)),
      ])
        .then(response => {
          const isFailed = _.some(response, o => {
            return !o.payload;
          });
          if (isFailed) return;
          form.scrollToField('reportScheduleName');
          form.resetFields();
          dispatch(reset());
          handleNextData();
        })
        .catch(() => {
          return;
        })
        .finally(() => {
          setUpdating(false);
        })
        .catch(() => {
          return;
        });
    }).catch(() => {
      return;
    });
  };

  const handleEditKr = () => {
    setIsOpenModalFormKr(true);
  };

  const handleCloseModelKr = () => {
    setIsOpenModalFormKr(false);
  };

  const handleEditObjective = () => {
    setIsOpenModalFormObjective(true);
  };

  const handleCloseModelObjective = () => {
    setIsOpenModalFormObjective(false);
  };

  const calculatorPercentByTrending = (calculation, numerator, denominator): number => {
    if (calculation === TrendingTypes.Above) {
      if (denominator > 0) return (numerator ?? 0) / denominator;
      return 0;
    }
    else {
      if (numerator > 0) return denominator / numerator;
      return 0;
    }
  }

  const renderNameAdjustment = (index: number, value: string) => {
    switch (index) {
      case 0:
        return `Dự phóng ${value}`
      case 1:
        return `Thực hiện ${value}`
      case 2:
        return `Thực hiện ${value}`
      case 3:
        return `Kế hoạch ${value}`
      case 7:
        return `Kế hoạch ${value}`
      case 8:
        return value.charAt(0).toUpperCase() + value.slice(1);
      case 9:
        return value.charAt(0).toUpperCase() + value.slice(1);
      case 10:
        return value.charAt(0).toUpperCase() + value.slice(1);
      default:
        return value.charAt(0).toUpperCase() + value.slice(1);
    }
  }

  const renderNameAdjustmentTarget = (index: number, value: string) => {
    switch (index) {
      case 0:
        return `Kế hoạch ${value}`
      case 1:
        return `Kế hoạch ${value}`
      case 2:
        return `Kế hoạch ${value}`
      case 3:
        return `Kế hoạch ${value}`
      case 4:
        return `${value.charAt(0).toUpperCase() + value.slice(1)}`
      case 5:
        return `${value.charAt(0).toUpperCase() + value.slice(1)}`
      case 6:
        return `${value.charAt(0).toUpperCase() + value.slice(1)}`
      case 7:
        return `Kế hoạch ${value}`
      case 8:
        return `${value.charAt(0).toUpperCase() + value.slice(1)}`
      case 9:
        return `${value.charAt(0).toUpperCase() + value.slice(1)}`
      case 10:
        return `${value.charAt(0).toUpperCase() + value.slice(1)}`
      case 11:
        return `Kế hoạch ${value}`

      default:
        return value;
    }
  }

  const handleChangeAdjustment = (value: string) => {
    setAdjustmentValue(value);
    setIsAdjustment(value);
  }

  return (
    <Spin spinning={isUpdating} delay={500}>
      <Form ref={modalContentRef} size="large" form={form} className='fw-bold' onFinish={handleSubmit} layout="vertical">
        <Title className="fw-bold" level={2}>
          {`Báo cáo thực hiện KR ${filters?.accountableName ? filters.accountableName : ''}`}
          {/* {`Báo cáo thực hiện KR quý 2`} */}
        </Title>
        <Row>
          <Col md={5}>
            <Form.Item label="Kỳ kế hoạch" name={'planPeriodName'}>
              {/* <Input className="w-100" disabled value={filters?.planPeriodName} size="large" /> */}
              <Input className="w-100" disabled size="large" />
            </Form.Item>
          </Col>
          {/* Sửa lại code ngu fix cứng tên sau khi gộp chức năng */}
          <Col md={1} />
          <Col md={5}>
            <Form.Item label="Kỳ báo cáo" name={'reportScheduleName'}>
              <Input size='large' className='w-100' readOnly />
            </Form.Item>
          </Col>
          {/* <Col md={1} />
          <Col>
            <div className="mt-4">
              <span className="cursor-pointer text-primary" onClick={() => handleEditKr()}>
                {`Xem chi tiết KR >`}
              </span>
              <br />
              <span className="cursor-pointer text-primary" onClick={() => handleEditObjective()}>
                {`Xem chi tiết mục tiêu >`}
              </span>
            </div>
          </Col> */}
        </Row>
        <Row>
          <Col md={11}>
            <Form.Item label="Mục tiêu">
              <TextArea rows={1} className="w-100" disabled value={objectiveEntity?.purpose ?? entity?.objective?.purpose} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={3}>
            <Form.Item label="Lĩnh vực">
              <Input className="w-100" disabled value={objectiveEntity?.fieldName ?? entity?.objective?.fieldName} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={3}>
            <Form.Item label="Dự án">
              <Input className="w-100" disabled value={objectiveEntity?.projectName ?? entity?.objective?.projectName} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={4}>
            <Form.Item label="Mảng công việc">
              <Input className="w-100" disabled value={objectiveEntity?.workTypeName ?? entity?.objective?.workTypeName} size="large" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col md={11}>
            <Form.Item label="Tên chỉ tiêu">
              <Input className="w-100" disabled value={entity?.keyResultYear?.metricName} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={5}>
            <Form.Item label="Đơn vị tính">
              <Input className="w-100" disabled value={entity?.keyResultYear?.metricUnit} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={6}>
            <Form.Item label="Chỉ tiêu năm">
              <InputNumber formatter={formatNumber} parser={parseNumber} className="w-100" disabled
                value={_.isInteger(entity?.keyResultYear?.metricValue) ? entity?.keyResultYear?.metricValue : entity?.keyResultYear?.metricValue?.toFixed(2)}
                size="large" />
            </Form.Item>
          </Col>
        </Row>
        <hr />

        <Row>
          <Col className="fw-bold h3" md={24}>
            Chốt kết quả thực hiện tháng 5
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <Form.Item label="Chỉ tiêu tháng 5">
              <InputNumber formatter={formatNumber} parser={parseNumber} className="w-100" disabled
                value={_.isInteger(entity?.keyResultPreviousMonth?.metricValue) ? entity?.keyResultPreviousMonth?.metricValue : entity?.keyResultPreviousMonth?.metricValue?.toFixed(2)}
                size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={4}>
            <Form.Item label="Ước thực hiện tháng 5">
              <InputNumber formatter={formatNumber} parser={parseNumber} className="w-100" disabled
                value={_.isInteger(entity?.keyResultPreviousMonth?.result) ? entity?.keyResultPreviousMonth?.result : entity?.keyResultPreviousMonth?.result?.toFixed(2)}
                size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={4}>
            <Form.Item label="Chốt thực hiện tháng 5" name="accumulateActualResultPreviousMonth" rules={[{ required: entity?.keyResultPreviousMonth?.actualResult !== 0 ? true : false, message: 'Hãy nhập chốt thực hiện tháng 5' }]}>
              <InputNumber formatter={formatNumber} parser={parseNumber} className="w-100" size="large" />
            </Form.Item>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col className="fw-bold h3" md={24}>
            {entity?.keyResultQuarter?.name}
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <Form.Item label="Chỉ tiêu quý II">
              <InputNumber formatter={formatNumber} parser={parseNumber} className="w-100" disabled
                value={_.isInteger(entity?.keyResultQuarter?.metricValue) ? entity?.keyResultQuarter?.metricValue : entity?.keyResultQuarter?.metricValue?.toFixed(2)}
                size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={4}>
            <Form.Item label="Chỉ tiêu tháng 6">
              <InputNumber formatter={formatNumber} parser={parseNumber} className="w-100" disabled
                value={_.isInteger(entity?.keyResultMonth?.metricValue) ? entity?.keyResultMonth?.metricValue : entity?.keyResultMonth?.metricValue?.toFixed(2)}
                size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={4}>
            <Form.Item
              label="Thực hiện tháng 6"
              rules={[{ required: entity?.keyResultMonth?.metricValue !== 0 ? true : false, message: 'Hãy nhập thực hiện tháng 6' }]}
              name={'metricValueMonth'}
            >
              <InputNumber step={0.01} precision={2} formatter={formatNumber} parser={parseNumber} className="w-100" size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={4}>
            <Form.Item rules={[{ required: entity?.keyResultQuarter?.metricValue !== 0 ? true : false, message: 'Hãy nhập thực hiện quý 2' }]} label="Thực hiện quý II" name={'metricValueQuarter'}>
              <InputNumber disabled={krCheckIn?.krType === KrTypes.AccumulateQuantitative} step={0.01} precision={2} formatter={formatNumber} parser={parseNumber} className="w-100" size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={4}>
            {krCheckIn?.krType === KrTypes.AccumulateQuantitative &&
              <Form.Item label="Thực hiện lũy kế từ đầu năm" name={'accumulateResult'}>
                <InputNumber disabled={entity?.keyResultQuarter?.evaluationMethodQuantitative === QuantitativeEvaluationType.Point} formatter={formatNumber} parser={parseNumber} className="w-100" size="large" />
              </Form.Item>
            }
          </Col>
        </Row>
        <Row>
          <Col md={9}>
            <Form.Item label="Tỷ lệ hoàn thành (%)">
              <TextArea rows={1} disabled className="w-100" value={entity?.keyResultQuarter?.evaluationMethodQuantitativeNote} size="large" />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={4}>
            <Form.Item label="KR tháng 6" name={'estimatePointMonth'}>
              <InputNumber
                formatter={formatNumber} parser={parseNumber}
                disabled={entity?.keyResultMonth?.evaluationMethodQuantitative === QuantitativeEvaluationType.Point}
                className="w-100"
                size="large"
                addonAfter="%"
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={4}>
            <Form.Item rules={[{
              required: entity?.keyResultQuarter?.evaluationMethodQuantitative === QuantitativeEvaluationType.SelfDefinition,
              message: 'Vui lòng nhập giá trị'
            }]} label="KR quý II" name={'estimatePointQuarter'}>
              <InputNumber
                disabled={entity?.keyResultQuarter?.evaluationMethodQuantitative === QuantitativeEvaluationType.Point}
                formatter={formatNumber} parser={parseNumber}
                className="w-100"
                size="large"
                addonAfter="%"
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={4}>
            {krCheckIn?.krType === KrTypes.AccumulateQuantitative &&
              <Form.Item label="Lũy kế so với KR năm" name={'accumulatePoint'}>
                <InputNumber
                  disabled={entity?.keyResultYear?.evaluationMethodQuantitative === QuantitativeEvaluationType.Point}
                  formatter={formatNumber} parser={parseNumber}
                  className="w-100"
                  size="large"
                  addonAfter="%"
                />
              </Form.Item>
            }
          </Col>
        </Row>
        <Row>
          <Col md={11}>
            <Form.Item
              label="Tình trạng KR tháng 6"
              rules={[{ required: entity?.keyResultMonth?.metricValue !== 0 ? true : false, message: 'Hãy chọn tình trạng kr quý 6' }]}
              name="workStatusMonth"
            >
              <Select
                filterOption={filterOption}
                allowClear
                showSearch
                size="large"
                options={workStatusList}
                placeholder="Chọn tình trạng"
              />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={12}>
            <Form.Item
              label="Tình trạng KR quý II"
              rules={[{ required: entity?.keyResultQuarter?.metricValue !== 0 ? true : false, message: 'Hãy chọn tình trạng kr quý II' }]}
              name="workStatusQuarter"
            >
              <Select
                filterOption={filterOption}
                allowClear
                showSearch
                size="large"
                options={workStatusList}
                placeholder="Chọn tình trạng"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col md={11}>
            {(workStatusMonthValues === StatusType.Postponed ||
              workStatusMonthValues === StatusType.Cancel ||
              workStatusMonthValues === StatusType.NotCompleted) && entity?.keyResultMonth?.metricValue !== 0 && (
                <Form.Item
                  label="Lý do (Không hoàn thành/Tạm dừng/Hủy)"
                  rules={[
                    {
                      required:
                        workStatusMonthValues === StatusType.Postponed ||
                        workStatusMonthValues === StatusType.Cancel ||
                        workStatusMonthValues === StatusType.NotCompleted,
                      message: `Hãy nhập lý do`,
                    },
                  ]}
                  name={'unFinishNoteMonth'}
                >
                  <TextArea rows={6} placeholder="Nhập nhập lý do" size="large" />
                </Form.Item>
              )}
          </Col>
          <Col md={1} />
          <Col md={12}>
            {(workStatusQuarterValues === StatusType.Postponed ||
              workStatusQuarterValues === StatusType.Cancel ||
              workStatusQuarterValues === StatusType.NotCompleted) && entity?.keyResultQuarter?.metricValue !== 0 && (
                <Form.Item
                  label="Lý do (Không hoàn thành/Tạm dừng/Hủy)"
                  rules={[
                    {
                      required:
                        workStatusQuarterValues === StatusType.Postponed ||
                        workStatusQuarterValues === StatusType.Cancel ||
                        workStatusQuarterValues === StatusType.NotCompleted,
                      message: `Hãy nhập lý do`,
                    },
                  ]}
                  name={'unFinishNoteQuarter'}
                >
                  <TextArea rows={6} placeholder="Nhập nhập lý do" size="large" />
                </Form.Item>
              )}
          </Col>
        </Row>
        <Row>
          <Col md={24}>
            <Form.Item label="Tài liệu đính kèm về kết quả thực hiện (link)" name={'noteQuarter'}>
              <TextArea placeholder="Nhập tài liệu đính kèm về kết quả thực hiện" size="large" />
            </Form.Item>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col className="fw-bold h3" md={24}>
            ĐIỀU CHỈNH KẾ HOẠCH NĂM {entity?.adjustment?.year}
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Form.Item label="Mục tiêu">
              <Select
                value={adjustmentValue}
                filterOption={filterOption}
                allowClear
                showSearch
                size="large"
                onChange={handleChangeAdjustment}
                options={[
                  {
                    label: 'Có điều chỉnh kế hoạch',
                    value: 'adjustment'
                  },
                  {
                    label: 'Không điều chỉnh kế hoạch',
                    value: 'noAdjustment'
                  }
                ]}
                placeholder="Chọn tùy chọn"
              />
            </Form.Item>
          </Col>
        </Row>
        {
          isAdjustment === 'adjustment' && <>
            <Row>
              <Col md={11}>
                <Form.Item label="Nội dung mục tiêu">
                  <TextArea rows={1} className="w-100" disabled value={objectiveEntity?.purpose ?? entity?.adjustment?.objective?.purpose} size="large" />
                </Form.Item>
              </Col>
              <Col md={1} />
              <Col md={3}>
                <Form.Item label="Lĩnh vực">
                  <Input className="w-100" disabled value={objectiveEntity?.fieldName ?? entity?.adjustment?.objective?.fieldName} size="large" />
                </Form.Item>
              </Col>
              <Col md={1} />
              <Col md={3}>
                <Form.Item label="Dự án">
                  <Input className="w-100" disabled value={objectiveEntity?.projectName ?? entity?.adjustment?.objective?.projectName} size="large" />
                </Form.Item>
              </Col>
              <Col md={1} />
              <Col md={4}>
                <Form.Item label="Mảng công việc">
                  <Input className="w-100" disabled value={objectiveEntity?.workTypeName ?? entity?.adjustment?.objective?.workTypeName} size="large" />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Form.Item>
                <span className="cursor-pointer text-primary" onClick={() => handleOpenModalAdjustmentObjective()}>
                  {`> Điều chỉnh mục tiêu`}
                </span>
              </Form.Item>
            </Row>
            <Row>
              <Col className="fw-bold h4" md={24}>
                Kết quả cần đạt được
              </Col>
            </Row>
            <Row>
              <Col md={11}>
                <Form.Item label="Chỉ tiêu">
                  <Input className="w-100" disabled value={entity?.keyResultYear?.metricName} size="large" />
                </Form.Item>
              </Col>
              <Col md={1} />
              <Col md={3}>
                <Form.Item label="Đơn vị tính">
                  <Input className="w-100" disabled value={entity?.keyResultYear?.metricUnit} size="large" />
                </Form.Item>
              </Col>
              <Col md={1} />
              <Col md={3}>
                <Form.Item label="Xu hướng">
                  <Input className="w-100" disabled value={entity?.keyResultYear?.metricTypeString} size="large" />
                </Form.Item>
              </Col>
            </Row>
            <Row className='mt-3'>
              <Col md={8}>
                <Row>
                  <Col md={8} />
                  <Col md={1} />
                  <Col className="fw-bold" md={15}>
                    Chỉ tiêu đã duyệt
                  </Col>
                </Row>
                {entity?.adjustment?.krApproved.map((x, index) => {
                  return (
                    <Row className="d-flex align-items-center" key={`approve-${index}`}>
                      <Col md={8}>
                        <span className="fw-bold">{renderNameAdjustmentTarget(index, x.name)}</span>
                      </Col>
                      <Col md={1} />
                      <Col className="mt-2" md={15}>
                        <Form.Item>
                          {
                            <InputNumber formatter={formatNumber} parser={parseNumber} disabled className="w-100" value={x.oldMetricValue} size="large" />
                          }
                        </Form.Item>
                      </Col>
                    </Row>
                  );
                })}
              </Col>
              <Col md={1} />
              <Col md={8}>
                <Row>
                  <Col md={8} />
                  <Col md={1} />
                  <Col className="fw-bold" md={15}>
                    Chỉ tiêu điều chỉnh
                  </Col>
                </Row>
                {entity?.adjustment?.krApproved.map((x, index) => {
                  return (
                    <Row className="d-flex align-items-center" key={`adjust-${index}`}>
                      <Col md={8} className='text-end'>
                        <span className="fw-bold mt-2">
                          {renderNameAdjustment(index, x.name)}
                        </span>
                      </Col>
                      <Col md={1} />
                      <Col className="mt-2" md={15}>
                        <Form.Item
                          initialValue={x?.metricValue} rules={[
                            { required: index === 0, message: "Vui lòng nhập giá trị" },

                          ]} name={`metricValue-${index}`}>
                          <InputNumber
                            parser={parseNumber}
                            formatter={formatNumber}
                            disabled={(krCheckIn?.krType === KrTypes.AccumulateQuantitative ? (index === 6 || index === 7 || index === 10) : undefined) || index === 1 || index === 2}
                            className="w-100"
                            step={0.01} precision={2}
                            onChange={e => {
                              handleChangeAdjustmentYear(e, index);
                            }}
                            size="large"
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  );
                })}
              </Col>
              <Col md={1} />
              <Col md={5}>
                <Row>
                  <Col className="fw-bold" md={24}>
                    So sánh
                  </Col>
                </Row>

                {entity?.adjustment?.krApproved.map((x, index) => {
                  return (
                    <Row className="mt-2" key={`compare-${index}`}>
                      <Col md={24}>
                        <Form.Item>
                          {
                            <InputNumber
                              parser={parseNumber}
                              formatter={formatNumber}
                              disabled
                              className="w-100"
                              value={compareAdjustmentYear[index]?.toFixed(2)}
                              size="large"
                              addonAfter="%"
                            />
                          }
                        </Form.Item>
                      </Col>
                    </Row>
                  );
                })}
              </Col>
            </Row>

            <Row>
              <Col md={24}>
                <Form.Item label="Lý do điều chỉnh kế hoạch" rules={[{ required: entity?.adjustment?.krApproved[0]?.metricValue !== metricValueYearValues, message: 'Vui lòng nhập lý do' }]} name={'reason'}>
                  <Input className="w-100" size="large" />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col md={11}>
                <Form.Item label="Khó khăn & nguyên nhân" name={'issue'}>
                  <TextArea rows={6} placeholder="Nhập khó khăn & nguyên nhân" size="large" />
                </Form.Item>
              </Col>
              <Col md={1} />
              <Col md={12}>
                <Form.Item label="Giải pháp và kiến nghị" name={'solution'}>
                  <TextArea rows={6} placeholder="Nhập giải pháp và kiến nghị" size="large" />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col md={24}>
                <Form.Item label="Tài liệu đính kèm về kết quả thực hiện (link)" name={'krAdjustmentNote'}>
                  <TextArea placeholder="Nhập tài liệu đính kèm về kết quả thực hiện" size="large" />
                </Form.Item>
                <Form.Item valuePropName="checked" name={'sendingNotification'}>
                  <Checkbox>Gửi thông báo đến người nhận</Checkbox>
                </Form.Item>
              </Col>
            </Row>
          </>
        }
        <Form.Item>
          <Row className="d-flex gap-3 mt-3" justify="end">
            {!hideNextKr &&
              <Col>
                <Button className="green" onClick={handleNextKr} disabled={isUpdating}>
                  Lưu & Chuyển sang check in KR khác
                </Button>
              </Col>
            }
            <Col>
              <Button
                className="secondary"
                onClick={() => {
                  handleClose();
                }}
              >
                Hủy
              </Button>
            </Col>
            <Col>
              <Button className="primary" htmlType="submit" disabled={isUpdating}>
                Lưu
              </Button>
            </Col>
          </Row>
        </Form.Item>
        {isOpenAdjustmentModel && (
          <AdjustObjectiveUpdate isOpen={isOpenAdjustmentModel} onClose={handleCloseModalAdjustmentObjective} id={entity?.objective?.id} />
        )}
        {isOpenModalFormObjective && (
          <ObjectiveUpdate isOpen={isOpenModalFormObjective} id={entity?.objective?.id} onClose={handleCloseModelObjective} />
        )}
        {isOpenModalFormKr && (
          <KRUpdate
            isOpen={isOpenModalFormKr}
            idKrBaseSelected={krCheckIn?.id}
            idObjective={entity?.objective?.id}
            krTypeRequest={krCheckIn?.krType}
            planPeriodType={filters?.planPeriodType}
            planPeriodIdSelected={filters?.planPeriodId}
            onClose={handleCloseModelKr}
          />
        )}
      </Form>
    </Spin >
  );
};

export default ReportQuantitativeResult;
